var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{staticStyle:{"height":"100vh"},attrs:{"type":"flex","align":"middle","justify":"center"}},[_c('el-col',{staticStyle:{"text-align":"center","color":"#303133"}},[_c('i',{staticClass:"el-icon-loading",staticStyle:{"font-size":"70px"}}),_c('div',{staticStyle:{"margin-top":"15px"}},[_vm._v("微信认证中...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }